import React from 'react';

export const PAGE_NAME = {
	leaguepass: 'leaguepass',
	packages: 'packages',
	video: 'video',
	category: 'category',
	videolist: 'videolist',
	episodeslist: 'episodeslist',
	nbatv: 'nbatv',
	tvguide: 'tvguide',
	channel: 'channel',
	featured: 'featured',
	shows: 'shows',
	classicgames: 'classicgames',
	search: 'search',
	event: 'event',
	subscription: 'subscription',
	account: 'account',
	business: 'business',
	music: 'music',
	notfound: 'notfound',
};

const routes = [
	{
		path: '/',
		exact: true,
		name: 'root',
		component: React.lazy(() => import('../pages/Featured.jsx')),
	},
	{
		path: '/league-pass',
		exact: true,
		name: 'leaguepass',
		component: React.lazy(() => import('../pages/Videos.jsx')),
	},
	{
		path: '/packages',
		name: 'packages',
		externalPage: true,
		component: React.lazy(() => import('../pages/Packages.jsx')),
	},
	{
		path: '/streaming-subscriptions',
		name: 'packages',
		externalPage: true,
		component: React.lazy(() => import('../pages/Packages.jsx')),
	},
	{
		path: '/video/:seoName',
		name: 'video',
		noScroll: true,
		component: React.lazy(() => import('../pages/Video.jsx')),
	},
	{
		// @deprecated
		path: '/category/:seoName',
		name: 'category',
		component: React.lazy(() => import('../pages/Category.jsx')),
	},
	{
		path: '/list/feed/:slug',
		exact: true,
		name: 'videolist',
		component: React.lazy(() => import('../pages/ESVideoList.jsx')),
	},
	{
		path: '/list/:curation/:slug',
		exact: true,
		name: 'videolist',
		component: React.lazy(() => import('../pages/NBAVideoList.jsx')),
	},
	{
		path: '/nba-tv',
		exact: true,
		name: 'nbatv',
		component: React.lazy(() => import('../pages/NBATv.jsx')),
	},
	{
		path: '/nba-tv/schedule',
		exact: true,
		name: 'tvguide',
		component: React.lazy(() => import('../pages/Schedule.jsx')),
	},
	{
		path: '/channel/:seoName',
		name: 'channel',
		noScroll: true,
		component: React.lazy(() => import('../pages/Channel.jsx')),
	},
	{
		path: '/featured',
		name: 'featured',
		component: React.lazy(() => import('../pages/Featured.jsx')),
	},
	{
		path: '/nba-tv/series',
		name: 'shows',
		component: React.lazy(() => import('../pages/Shows.jsx')),
	},
	{
		path: '/nba-tv/classic-games',
		name: 'classicgames',
		component: React.lazy(() => import('../pages/ClassicGames.jsx')),
	},
	{
		path: '/page/search',
		name: 'search',
		component: React.lazy(() => import('../pages/Search.jsx')),
	},
	{
		path: '/event/:seoName',
		name: 'event',
		noScroll: true,
		component: React.lazy(() => import('../pages/Event.jsx')),
	},
	{
		path: '/secure/subscription',
		name: 'subscription',
		component: React.lazy(() => import('../pages/Subscription.jsx')),
		externalPage: true,
	},
	{
		path: '/account/:pageName',
		name: 'account',
		component: React.lazy(() => import('../pages/Account.jsx')),
		externalPage: true,
	},
	{
		path: '/page/business',
		name: 'business',
		externalPage: true,
		component: React.lazy(() => import('../pages/Static.jsx')),
	},
	{
		path: '/page/music',
		name: 'music',
		externalPage: true,
		component: React.lazy(() => import('../pages/Static.jsx')),
	},
	{
		path: '/gridtest',
		name: 'gridtest',
		component: React.lazy(() => import('../pages/GridTest.jsx')),
	},
	{
		path: '/itemtest',
		name: 'itemtest',
		component: React.lazy(() => import('../pages/ItemTest.jsx')),
	},
	{
		path: '*',
		name: 'notfound',
		component: React.lazy(() => import('../pages/NotFound.jsx')),
	},
];

export default routes;
